import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LabelledText } from 'components/LabelledText/LabelledText';
import { ReactElement } from 'react';
import PullOutDesignResistance from '../../assets/images/PullOutDesignResistance.svg';
import PullOverDesignResistance from '../../assets/images/PullOverDesignResistance.svg';
import { Fasteners } from '../../types/domainTypes';

export interface FastenerRecommendationProps {
  fastenersRecommendation: Fasteners;
}

export const FastenerRecommendation = ({ fastenersRecommendation }: FastenerRecommendationProps): ReactElement | null => {
  const { t } = useTranslation();
  const { fastenerName, pullOutDesignResistance, pullOverDesignResistance, testStandard, notes } = fastenersRecommendation;
  if (!fastenerName || !pullOutDesignResistance || !pullOverDesignResistance || !testStandard || !notes) {
    return null;
  }

  return (
    <Box sx={{ pt: 4 }}>
      <Typography variant="h6" fontFamily="KingspanBrownTT-Bold" sx={{ pb: 2 }}>
        {t('calculation-page.fasteners-details-dialog.fastener-recommendation-title')}
      </Typography>
      <Stack spacing={2}>
        <LabelledText
          data-testid="fastener-name"
          label="calculation-page.fasteners-details-dialog.label-fastener-name"
          value={fastenerName}
        />
        <LabelledText
          data-testid="pull-out-design-resistance"
          label="calculation-page.fasteners-details-dialog.label-pull-out-design-resistance"
          value={pullOutDesignResistance.toString()}
          labelIcon={
            <img
              style={{ marginLeft: '.8655rem' }}
              src={PullOutDesignResistance}
              alt="Pull-out design resistance"
              data-testid="Pull-out-design-resistance-img"
            />
          }
        />
        <LabelledText
          data-testid="pull-over-design-resistance"
          label="calculation-page.fasteners-details-dialog.label-pull-over-design-resistance"
          value={pullOverDesignResistance.toString()}
          labelIcon={
            <img
              style={{ marginLeft: '.5rem' }}
              src={PullOverDesignResistance}
              alt="Pull-over design resistance"
              data-testid="Pull-over-design-resistance-img"
            />
          }
        />
        <LabelledText
          data-testid="test-standard"
          label="calculation-page.fasteners-details-dialog.label-test-standard"
          value={testStandard}
        />
        <LabelledText data-testid="notes" label="calculation-page.fasteners-details-dialog.label-notes" value={notes} />
      </Stack>
    </Box>
  );
};
